var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 4.5V6H8.25V4.5H15.75Z",
    fill: "#696F88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93681 9.75H15.75V8.25H4.93681L6.75 6.3075L5.76014 5.25L2.25 9L5.76014 12.75L6.75 11.6925L4.93681 9.75Z",
    fill: "#696F88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 13.5H15.75V12H8.25V13.5Z",
    fill: "#696F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarClose);
export default __webpack_public_path__ + "static/media/sidebar_close.12ffe17a12693a12fc33ea598240b4aa.svg";
export { ForwardRef as ReactComponent };